import React, { Component } from 'react'

import './RaisedButton.css'

export default class RaisedButton extends Component {
  render () {
    return (
      <div style={this.props.style} onClick={this.props.onClick} className='button button-sm raised-button'>{this.props.text || 'Lorem ipsum'}</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/RaisedButton.js